"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _default = exports.default = {
  fiCommon: {
    query: 'Search',
    reset: 'Reset',
    add: 'Add',
    copy: 'Copy ',
    export: 'Export',
    exports: 'Batch Export',
    save: 'Save',
    updates: 'Batch Updates',
    saveAndAdd: 'Save And Add',
    submit: 'Submit',
    cancel: 'Cancel',
    goBack: 'Back',
    operation: 'Operate',
    edit: 'Edit',
    detail: 'Detail',
    delete: 'delete',
    createReceipt: 'Generate',
    lookImage: 'Check Image',
    look: 'Check',
    writeOff: 'Red-Ink Entry',
    delSection: 'Del Section',
    exportInOut: 'Export IN-OUT Detail',
    exportEntry: 'Export Entry',
    unsend: 'Unsend',
    ywedit: 'Adjustment',
    confirm: 'Confirm',
    section: 'Section',
    downloadTemplate: 'Download Template',
    importTemplate: 'Import'
  },
  finance: {
    title: {
      financeManage: 'Manage Finance',
      ruleConfig: 'Finance Rule Config',
      fiReceiptSearch: 'Query Receipt',
      fiReceiptManage: 'Manage Receipt',
      financeOrder: 'Query Finance Order',
      receiptMonth: 'Receipt Month Statistics',
      dockRepairSearch: 'Dock Repair Search',
      dataChangeMonitor: 'Data Exchange Monitor',
      dataSendMonitor: 'Data Send Monitor',
      dataReceiveMonitor: 'Data Receive Monitor',
      fiBizInOut: '库存动态',
      accountGroupManage: 'Account Group Manage'
    },
    filter: {
      manageCompany: 'Company',
      vessel: 'Vessel',
      category: 'Category',
      currency: 'Currency',
      vesselType: 'Vessel Type',
      busiType: 'Business Type',
      supplier: 'Supplier',
      debitCredit: 'Debit Or Credit',
      module: 'Module',
      operateType: 'Operate Type'
    },
    prompt: {
      saveSuccess: 'Success',
      saveFaild: 'Failed',
      createSuccess: 'Success',
      createFaild: 'Failed',
      submitAgain: "Please don't submit again",
      saveAgain: "Please don't save again",
      createAgain: "Please don't generate again",
      deleteSuccess: 'Success',
      deleteFaild: 'Failed',
      submitSuccess: 'Success',
      submitFaild: 'Failed',
      operSuccess: 'Success',
      operFaild: 'Failed',
      tip: 'Tips',
      yes: 'Y',
      no: 'N',
      confirm: 'Confirm',
      cancel: 'Cancel',
      searchFaild: 'Failed'
    },
    placeholder: {
      selectDate: 'Select Date',
      selectYearMonth: 'Select Year And Month'
    },
    financePayment: {
      title: '预付\应付单集成管理',
      filter: 'Filter',
      keyWord: 'Key word',
      rules: {
        pleaseEnterKeyWord: 'Please Enter Keyword'
      }
    },
    dock: {
      keyWord: 'Key word',
      dataReinput: '数据回写',
      vesselName: 'Vessel Name',
      dockRepair: '坞修航次',
      dockStartDate: '坞修开始日期',
      dockEndDate: '坞修结束日期',
      business: '业务科目',
      currency: '币种',
      deferred: '待摊费用',
      dockRepairCost: '坞修成本',
      capitalization: '资本化',
      totalAmount: '总金额',
      conversion: '期末折算汇率',
      convertedCurrency: '折算本位币',
      receive: {
        receiveSuccess: '回写成功',
        receiveFaild: '回写失败',
        receiveData: '回写数据',
        receive: '回写',
        receiveContent: '回写报文',
        pleaseInputReceiveMessage: '请输入返回的信息'
      },
      filter: {
        vesselName: '船名',
        applyDate: '申领日期'
      },
      rules: {
        pleaseEnterKeyWord: 'Please Enter Keyword'
      }
    },
    inventory: {
      searchSection: '查询区间',
      amountInOriginal: '原币金额',
      selectDate: '选择年月',
      searchFaild: '搜索失败',
      deleteMouth: '确定要删除本月切片数据吗？',
      nonMouthGenerate: '本月未生成切片数据',
      hint: '提示',
      yes: '是',
      no: '否',
      deleteSuccess: '删除成功',
      deleteFaild: '删除失败',
      generateData: '切片数据生成中...',
      rules: {
        pleaseSelectCompany: '请选择管理公司',
        pleaseSelectGenerateCompany: '请选择要切片的公司'
      }
    }
  },
  ruleConfig: {
    title: 'Rule Config',
    detail: 'Detail',
    table: {
      vesselCode: 'Vessel Code',
      debit: 'debit',
      credit: 'credit',
      HKWShippingCO: 'Hong Kong Ming Wah Shipping CO., LTD.',
      HKWManageCo: 'HONG KONG MING WAH SHIP MANAGEMENT CO., LTD.'
    },
    query: {
      sceneCode: 'Scene Code',
      feeCode: 'Fee Code',
      companyName: 'Company',
      all: 'All Config'
    },
    form: {
      companyName: 'Company',
      chargeName: 'Charge Name',
      vesselType: 'Vessel Name',
      accountType: 'Account Type',
      businessName: 'Business Name',
      operateType: 'Operate Type',
      accountSet: 'Account Set',
      debitCredit: 'Debit Or Credit',
      debitCode: 'Debit Code',
      debitName: 'Debit Name',
      debitFeeCode: 'Debit Fee Code',
      creditCode: 'Credit Code',
      creditName: 'Credit Name',
      creditFeeCode: 'Credit Fee Code',
      accountGroup: 'Account Group',
      sceneCode: 'Scene Code',
      sceneName: 'Scene Name',
      version: 'Version',
      startTime: 'Active Time',
      endTime: 'Inactive Time',
      remark: 'Remark'
    },
    prompt: {
      pleaseInput: 'Please Enter',
      acquisitionFailure: 'Failed',
      saveSuccess: 'Success',
      saveFalse: 'Failed',
      chargeNotNull: 'Please Select Charge ',
      vesselTypeNotNull: 'Please Select Vessel Type',
      accountTypeNotNull: 'Please Select AccountType',
      businessTypeIdNotNull: 'Please Select Business Type',
      operateTypeNotNull: 'Please Select Operate Type',
      accountSetNotNull: 'Please Select Account Set',
      debitCreditFlagNotNull: 'Please Select Debit Or Credit',
      debitCodeNotNull: 'Please Enter Debit Code',
      creditCodeNotNull: 'Please Enter Credit Code',
      selectCompanyAdd: 'PLease Add After Select Your Company',
      projectNotNull: 'Please Select Account Group',
      vesselNotNull: 'Please Select Vessel',
      deptNotNull: 'Please Select Dept',
      easDeptNotNull: 'Please Enter EAS Dept Code',
      tips: 'prompt',
      startTime: 'Please Enter Start Time',
      confirmMsg: 'confirm',
      cancelMsg: 'cancle',
      confirmSub: 'Confirm to submit?',
      deleteTip: 'Confirm to delete?',
      deleteSuc: 'successfully deleted',
      deleteFail: 'failed to delete',
      candelDel: 'cancel delete',
      rules: {
        pleaseSelectCopyData: '请选择要复制的数据'
      },
      dialog: {
        getFaild: '获取失败'
      }
    }
  },
  receiptInfo: {
    receiptDetail: 'Receipt Detail',
    generateReceipt: 'Generate Receipt',
    writeOffReceipt: 'Red_Ink Entry',
    receiptAccount: 'Account Group',
    receiptInOut: 'In Out Record',
    orderReceipt: 'Order Provisional Estimate Write-Off Information',
    baseInfo: 'Base Info',
    btn: {
      add: 'Add'
    },
    tip: {
      select: 'Please Select Receipt Item For Operation',
      adjustment: 'Adjustment Can Only Be Performed When It Is Registered',
      limit: 'Only One Piece Of Fata Can Be Delected For Adjustment'
    },
    query: {
      busiCode: 'Business Code',
      origCode: 'Origin Code',
      accountDate: 'Account Date',
      sceneCode: 'Scene',
      accountYearMonth: 'Account Year And Month',
      companyCode: 'Company Code',
      orderNo: 'Order NO',
      feeCode: 'Fee Code',
      voucherNo: 'Voucher NO'
    },
    tab: {
      all: 'All',
      register: 'Register',
      waitSend: 'Wait For Send',
      sended: 'Sended',
      sendSuccess: 'Success',
      sendFail: 'Failed',
      noSend: 'Not To Send'
    },
    form: (0, _defineProperty2.default)({
      receiptCode: 'Origin Code',
      vesselCode: 'Vessel Code',
      vesselName: 'Vessel Name',
      companyCode: 'Company Code',
      accountDate: 'Account Date',
      sceneCode: 'Scene Code',
      voucherNo: 'Voucher NO',
      businessInvoiceDate: 'Business Date/Invoice Date',
      businessDate: 'Business Date',
      sceneName: 'Scene Name',
      sendStatus: 'Send Status',
      accountYearMonth: 'Account Year Month',
      imageCode: 'Image Code',
      receiptRemark: 'Summary',
      staEndTime: 'Statistics End Time',
      createTime: 'Create Time',
      debitFeeCode: 'Debit Fee',
      creditFeeCode: 'Credit Fee',
      debitFeeName: 'Debit Fee Name',
      creditFeeName: 'Credit Fee Name'
    }, "voucherNo", 'Voucher No'),
    prompt: {
      writeOffSuccess: '红冲成功',
      writeOffFaild: '红冲失败',
      getFaild: '获取失败',
      generattingReceipt: '万能单据生成中...',
      pleaseSelectGenerateCompany: '请选择要生成万能单据的公司',
      selectCompany: 'Please Select Company',
      confirmSubmit: 'The universal order successfully sent after submission cannot be modified,Confirm That You Want To Submit The Selected Data?',
      selectRegister: 'Please Select Registred Data To Perform Operation',
      selectRegOrNosend: 'Please Select Registered Or Unsend Or Failed Data To Submit',
      selectSubmitData: 'Please Select The Data To Submit',
      confirmDelete: 'Confim If You Want To Delete This Record',
      dataDelete: 'Only Registered Or Unsend Data Can be Deleted',
      cancelDelete: 'Delete Cancel',
      selectItem: 'Please Select Item Data',
      selectReceipt: 'PLease Select',
      unsendReceipt: 'Confirm That You Want To Make The Select Data To Unsend?',
      selectOperData: 'Please Select The Data To Operate',
      editUnSend: 'Only The Unsend Data Can be Adjusted',
      selectedList: 'Please Select The Universal Document Not To Be Sent For Operation',
      rules: {
        remarkNotNull: '备注信息不能为空'
      },
      order: {
        Estimate: '暂估',
        Consume: '消耗',
        Invoice: '发票',
        RedDashed: '发票红冲',
        EstimatedWriteOff: '暂估冲销',
        searchFaild: '搜索失败',
        parts: '备件',
        fuel: '物料',
        trans: '调拨单',
        afterPay: '付款后签收',
        newShip: '新造船'
      },
      receipt: {
        searchFaild: '搜索失败'
      }
    }
  },
  receiptItem: {
    title: 'Receipt Item',
    form: {
      supplierCode: 'Supplier Code',
      supplierName: 'Supplier Name',
      orderNo: 'Order NO',
      categoryCode: 'Categroy Code',
      businessCode: 'Business Code',
      categoryName: 'Category Name',
      debitCredit: 'Debit Or Credit',
      debitFeeCode: 'Debit Fee Code',
      creditFeeCode: 'Credit Fee Code',
      originalAmount: 'Original Amount',
      currency: 'Currency',
      rate: 'Rate',
      localCurrencyAmount: 'Local Currency Amount',
      projectNum: 'Project Num',
      businessNo: 'Business NO',
      itemSummary: 'Summary'
    },
    inOutForm: {
      control: 'Under Control',
      vesselName: 'Vessel Name',
      orderNo: 'Order NO',
      materialName: 'Material Name',
      inOrOut: 'OutBound/InBound',
      inOutType: 'InOut Type',
      inOutDate: 'In Out Data',
      quantity: 'Quantity',
      price: 'Price',
      totalAmount: 'Total Amount',
      orderPrice: 'Order Price',
      discount: 'Discount%',
      invoicePrice: 'Invoice Price',
      discountUnit: 'Discounted Price',
      currency: 'Currency',
      rate: 'Rate',
      chargeName: 'Biz Type',
      displayOrder: 'Display order'
    },
    order: {
      index: 'No.',
      estimate: 'Esitmate Amount',
      reverse: 'Reverse Amount',
      noreverse: 'Remain Reverse Amount',
      reversalAmount: 'This Time Reverse Amount',
      reversalBalance: 'Balance'
    },
    receiptDetail: {
      countTotal: '总价合计'
    },
    prompt: {
      searchFaild: '搜索失败',
      getFaild: '获取失败'
    }
  },
  receiptMonth: {
    inventoryDetail: 'Inventory Statistics Detail',
    title: {
      section: 'Section'
    },
    form: {
      endAmountLocal: 'End Local Amount',
      vesselName: 'Vessel Code-Vessel Name',
      categoryName: 'Category Code-Category Name',
      currency: 'Currency',
      startAmount: 'Start Amount',
      nowAddPayment: 'Current Add（AP Receipt)',
      nowAddReceipt: 'Current Add（Receipt)',
      nowReduce: 'Current Reduce',
      endAmount: 'End Amount',
      oraginalAmount: 'Origin Amount',
      localAmount: 'Local Amount',
      endRate: 'End Rate',
      openAmountLocal: 'Stock Financial Conversion Local Currency'
    },
    detail: {
      receiptCode: 'Origin Code',
      monthType: 'Month Type',
      accountDate: 'Account Date',
      orderNo: 'Order NO',
      currency: 'Currency',
      rate: 'Rate',
      oriAmount: 'Origin Amount',
      localAmount: 'Local Amount',
      memo: 'Remark',
      startAmount: 'Start Origin Amount',
      startAmountLocal: 'Start Local Amount',
      betweenAmount: 'Interval Origin Amount',
      betweenAmountLocal: 'Interval Local Amount',
      endAmount: 'End Origin Amount',
      endAmountLocal: 'End Local Amount'
    },
    prompt: {
      getFaild: '获取失败'
    },
    sectionDate: 'Section Date'
  },
  fiDictionary: {
    groupTitle: 'Account Group Config',
    groupDetail: 'Detail',
    groupForm: {
      dispOrder: 'Display Order',
      accountGroup: 'Account Group'
    },
    query: {
      charge: 'Charge',
      category: 'Category Code/Name',
      department: 'Dept Code/Name',
      easDept: 'EAS Dept Code'
    },
    configTitle: 'Category Conifg',
    configForm: {
      categoryCode: 'Category Code',
      categoryName: 'Category Name',
      chargeId: 'ChargeId',
      chargeCode: 'Charge Code',
      chargeNameCn: 'Chinese Charge Name',
      chargeNameEn: 'English Charge Name',
      dispOrder: 'Display Order',
      module: 'Module',
      vessel: 'Vessel',
      department: 'Department',
      vesselNameCn: 'Vessel Chinese Name',
      vesselNameEn: 'Vessel English Name',
      deptCode: 'Dept Code',
      deptNameCn: 'Dept Chinese Name',
      deptNameEn: 'Dept English Name',
      easDeptCode: 'EAS Dept Code'
    },
    from: {
      pleaseSelect: '请选择'
    },
    prompt: {
      categoryCodeNotNull: 'Please Enter Category Code',
      tips: 'prompt',
      getFaild: '获取失败',
      startTime: 'Please Enter Start Time',
      confirmMsg: 'confirm',
      cancelMsg: 'cancle',
      confirmSub: 'Confirm to submit?',
      deleteTip: 'Confirm to delete?',
      deleteSuc: 'successfully deleted',
      deleteFail: 'failed to delete',
      candelDel: 'cancel delete'
    }
  },
  dataMonitor: {
    query: {
      busiCode: 'Business Code',
      origCode: 'Origin Code',
      interfaceName: 'Interface Name',
      receiveContent: 'Receive Content',
      receiveTime: 'Receive Time',
      sendTime: 'Send Time'
    },
    form: {
      busiType: 'Business Type',
      busiCode: 'Business Code',
      origCode: 'Origin Code',
      sendContent: 'Send Content',
      sendTime: 'Send Time',
      sendCount: 'Send Count',
      responseInfo: 'Response Info',
      responseTime: 'Response Time',
      sendStatus: 'Send Status',
      errorMessage: 'Error Message',
      interfaceName: 'Interface Name',
      receiveTime: 'Receive Time',
      receiveContent: 'Receive Content',
      returnContent: 'Back Content',
      receiveFlag: 'Receive Flag'
    },
    tab: {
      all: 'All',
      recSuccess: 'Success',
      recFaild: 'Failed',
      sendSuccess: 'Success',
      sendFail: 'Failed',
      waitSend: 'Wait For Send',
      sended: 'Sended',
      noSend: 'Not To Send'
    },
    prompt: {
      toBeSend: 'To be send',
      sent: 'sent',
      sendSuccess: 'Send successfully',
      sendFaild: 'Send failed',
      searchFaild: 'Search Failed',
      getFaild: 'Get Failed',
      receiveFailed: 'Receive Failed',
      receiveSuccess: 'Receive Success',
      rules: {
        pleaseSelectSearchData: '请选择要查看的数据'
      }
    }
  },
  safetyProductCost: {
    safetyFlag: 'Safety Flag',
    addTips: 'Added Successfully !',
    dialogTitleName: 'Review Of Safety Production Cost',
    titleName: 'Settlement Center',
    minTitleName: 'Safety Production Cost Management',
    draft: 'Draft',
    toSubmitted: 'To Be Submitted',
    reviewing: 'Under Review',
    reviewed: 'Reviewed And Approved',
    normalOrder: 'Normal Order',
    cancelOrder: 'Order Cancelled',
    confirmation: 'Bill Confirmation',
    spare: 'Spare Part',
    material: 'Material',
    repairShip: 'Repair Ship',
    survey: 'Survey',
    test: 'Test',
    signedNot: 'Signed Not',
    partial: 'Partial Teceipt',
    signeded: 'Sign In Completed',
    dialogTips: 'Including safety production cost, cannot be empty',
    dialogTips1: 'There must be at least one summary list data',
    dialogTips2: 'At least one safety production fee must be selected in the project list!',
    checkSafeFlag: 'Please select safety Fee Type!',
    selectList: {
      moduleFlag: 'Order Type',
      moduleFlagO: 'Spare Part',
      moduleFlagTW: 'Material',
      moduleFlagTH: 'Ship Repair',
      moduleFlagF: 'Survey'
    },
    table: {
      orderNo: 'Order No',
      vesselName: 'Vessel Name',
      orderDate: 'Order Date',
      completeDate: 'Sign/Complete Date',
      payConfirmDate: 'Pay ConfirmDate',
      auditDate: 'Audit Date',
      receiptDate: 'Voucher Date',
      chargeName: 'Business Account',
      module: 'Order Type',
      supplierName: 'Supplier Name',
      currency: 'Original Currency',
      currencyLocal: 'Currency Local',
      rate: 'Rate',
      orderAmount: 'Order Amount',
      orderAmountLocal: 'Order Amount Local',
      safetyAmount: 'Safety Amount',
      safetyAmountLocal: 'Safety Amount Local',
      orderStatus: 'Order Status',
      reviewStatus: 'Audit Status',
      submitMen: 'Submit Men',
      sumitDate: 'Sumit Date'
    },
    dialog: {
      info: 'Basic Information',
      vesselName: 'Vessel Name',
      orderNo: 'Order Code',
      orderStatus: 'Order Status',
      signStatus: 'Sign Status',
      module: 'Module',
      supplierName: 'Supplier Name',
      orderAmount: 'Order Amount',
      currency: 'Currency',
      safetyAmount: 'Safety Amount',
      reviewStatus: 'Audit Status',
      safetyFlag: 'Safety Flag',
      yes: 'Yes',
      no: 'No',
      safetyChargeId: 'Safety Fee Type',
      subtotalsName: 'Safety Fee Group Information',
      auditAmount: 'Est Amount ',
      actualAmount: 'Actual Amount',
      itemInfo: 'Item Information ',
      itemNo: 'Item No',
      itemName: 'Item Name',
      itemQuantity: 'Quantity',
      itemUnit: 'Unit',
      itemUnitPrice: 'Price',
      discount: 'Discount',
      amount: 'Amount',
      hasSafetyFlag: 'Safety Flag',
      discountUnitPrice: 'Discount Unit Price',
      discountAmount: 'Discount Amount',
      totoalAuditAmount: 'Totoal Audit Amount',
      totoalActualAmount: 'Totoal Actual Amount',
      taxRate: 'Tax Rate'
    }
  },
  safetyProductCostStatistics: {
    queryTips: 'The order date range cannot span years, please re-select',
    percentage: 'Time Progress Percentage',
    accruedAmount: 'Total accrued (budgeted) amount',
    actualAmount: 'Percentage of actual total amount in total accrued (budgeted) amount',
    totalAmountLocal: 'Total Amount Local',
    title: 'Safety Product Cost Statistics',
    orderType: 'Order Type',
    survey: 'Survey',
    safetyType: 'Safety Type',
    applyStartDate: 'Apply Start Date',
    applyEndDate: 'Apply End Date',
    originalAmount: 'Original Amount',
    localAmount: 'Local Amount'
  }
};